import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { WjGridModule } from '@grapecity/wijmo.angular2.grid';

import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';


import { KYMW0903Component } from './kymw0903.component';

/**
 * 注文コード割当確認画面 モジュール設定クラス
 *
 * @export KYMW0903Module
 * @class KYMW0903Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
  ],
  declarations: [
    KYMW0903Component,
  ],
  providers: [
  ],
})
export class KYMW0903Module {

}
